import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation,useHistory, useParams } from "react-router-dom";

const OrderDetail = () => {
  const location = useLocation();
  const {datas}=useParams()

  const [data,setData]=useState([])
  const status = location?.state?.status;
//   const histrory=useHistory()
  console.log("history data==>",datas)

  
  useEffect(() => {
    axios
      .get(
        `https://app1.crazzyhub.com/sales-order-list-/?store_id=&from_date=&to_date=&order_status=&page=&sales_order_id=`,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        setData(response?.data?.data)
        // console.log("order data==>", response?.data?.data);
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
        // toast.error(error.message);
      });
  }, []);

  return <>this is order details page</>;
};

export default OrderDetail;
